module.exports = __webpack_public_path__ + "img/2026-03-24b_2.a27a70e7.jpg";